<template>
  <div>
    <el-dialog
        title="接单记录"
        :lock-scroll="true"
        :visible.sync="dialogFormVisible"
        width="950px"
        :close-on-click-modal="false"
        :key="key"
    >
      <section class="dialogContent">
        <TableBox ref="tableBox" @closeModal="dialogFormVisible=false"/>
      </section>
      <section slot="footer" class="dialog-footer">
        <el-button  type="primary" @click="cancle">关闭</el-button>
<!--        <el-button type="primary" @click="choose" :loading="subLoading"-->
<!--        >确定</el-button-->
<!--        >-->
      </section>
    </el-dialog>
  </div>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import TableBox from './tableBox';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableBox,
  },
  data () {
    return {
      dialogFormVisible: false,
      subLoading: false,
      sourceOfGoodsId: '',
      key: '',
    };
  },
  watch: {
    dialogFormVisible (val) {
      if (!val) {
        this.key = Math.random();
      }
    },
  },
  methods: {
    show (item) {
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs.tableBox.saveSearchBoxData({sourceOfGoodsId: item.id});
      });
    },
    cancle () {
      this.dialogFormVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.dialogContent {
  padding-bottom: 24px;
}
.searchBox {
  ::v-deep .customForm {
    margin: 0;
  }
}
::v-deep .el-radio-group {
  width: 100%;
}
.chooseShowBox {
  height: 32px;
  line-height: 32px;
  width: 240px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  padding: 0 15px;
  border-radius: 4px;
  color: #c0c4cc;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .downIcon {
    font-size: 14px;
    right: 5px;
    top: 8px;
    color: #c0c4cc;
  }
}
.active {
  color: #333;
}
</style>
